<div class="row justify-content-center p-5" *ngIf="loadingSignal">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>

<div class="row p-2" *ngIf="!isWorldWatchUser && !loadingSignal">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">
        <div style="padding: 1rem; border-color: #ff0000 !important; border: 0.125rem solid transparent;">
            <div>
                <h3>{{ 'pages.worldwatch.noAccess.heading' | translate }}</h3>
            </div>
            <div>
                <p [innerHTML]="'pages.worldwatch.noAccess.body' | translate"></p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="signal">
    <div  class="head">
        <span class="category"
            [ngClass]="signal.signalUrgency + signal.mainCategory | lowercase | removeWhiteSpace"></span>
        <span class="title">{{signal.summary}}</span>
    </div>
    <table aria-describedby="additional information" class="signal table table-striped table-responsive">
        <thead>
            <tr>
                <th style="width: 20%;"></th>
                <th style="width: 60%;"></th>
                <th style="width: 20%;"></th>
            </tr>
        </thead>
        <tbody>
            <!-- reference -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.reference' | translate }}</td>
                <td>{{signal.jiraRef}}</td>
                <td>
                    <button [disabled]="!haveTicket" class="btn btn-primary me-1"
                        [routerLink]="['/support/dashboard/' + signalRef]">{{ 'pages.generic.viewTickets' | translate
                        }}</button>
                    <button class="btn btn-primary" [routerLink]="['/support/log/']"
                        [queryParams]="{signalRef: signalRef}">{{ 'pages.generic.logTicket' | translate }}</button>
                </td>
            </tr>

            <!-- urgency -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.urgency' | translate }}</td>
                <td>{{signal.signalUrgency | uppercase}}</td>
                <td></td>
            </tr>

            <!-- mainCategory -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.mainCategory' | translate }}</td>
                <td>{{signal.mainCategory | uppercase}}</td>
                <td></td>
            </tr>

            <!-- categories -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.categories' | translate }}</td>
                <td>
                    <div *ngFor="let s of signal.categories">{{s.value}}</div>
                    <span *ngIf="!signal.categories">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- lastUpdate -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.lastUpdate' | translate }}</td>
                <td>{{signal.date | date: 'dd/MM/yyyy HH:mm'}} GMT</td>
                <td></td>
            </tr>

            <!-- executiveSummary -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.executiveSummary' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.executiveSummary | formatHtml"></span>
                    <span *ngIf="!signal.executiveSummary">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- whatYouWillHear -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.whatYouWillHear' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.whatYouWillHear | formatHtml"></span>
                    <span *ngIf="!signal.whatYouWillHear">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- whatItMeans -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.whatItMeans' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.whatItMeans | formatHtml"></span>
                    <span *ngIf="!signal.whatItMeans">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- whatWeAreDoing -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.whatWeAreDoing' | translate }}</td>
                <td>
                    <div *ngIf="signal.servicesAffected">
                        {{ 'pages.updates.signal.fieldTitles.servicesConsumedPre' | translate }}<br />
                        <ul>
                            <span *ngFor="let s of signal.servicesAffected" class="ps-2">
                                <li>{{s.value}}</li>
                            </span>
                        </ul>
                        <br />
                        {{ 'pages.updates.signal.fieldTitles.servicesConsumedPost' | translate }}
                        <br /><br />
                    </div>
                    <span class="preserve-whitespace" [innerHTML]="signal.whatWeAreDoing | formatHtml"></span>
                    <span *ngIf="!signal.whatWeAreDoing">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- whatYouShouldDo -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.whatYouShouldDo' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.whatYouShouldDo | formatHtml"></span>
                    <span *ngIf="!signal.whatYouShouldDo">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- readMore -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.readMore' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.readMore | linkify | formatHtml"></span>
                    <span *ngIf="!signal.readMore">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- geopoliticalComments -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.geopoliticalComments' | translate }}</td>
                <td><span class="preserve-whitespace" *ngIf="signal.geopoliticalComments"
                        [innerHTML]="signal.geopoliticalComments | formatHtml"></span>
                    <span *ngIf="!signal.geopoliticalComments">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- iocFull -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.iocFull' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.ioc | formatHtml"></span>
                    <span *ngIf="!signal.ioc">N/A</span>
                </td>
                <td></td>
            </tr>

            <!-- tags -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.tags' | translate }}</td>
                <td>
                    <ul>
                        <li *ngFor="let s of signal.tags">
                            <a [routerLink]="['/updates/worldwatch/viewTag/' + s]"
                                routerLinkActive="router-link-active">{{s}}</a>
                        </li>
                    </ul>
                </td>
                <td></td>
            </tr>

            <!-- updates -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.updates' | translate }}</td>
                <td>
                    <div class="preserve-whitespace" *ngFor="let s of signal.comments">
                        {{s.comment}}<br />
                        <small class="text-muted">{{s.author}} - {{ s.date | date:'dd/MM/yyyy HH:mm'}}</small><br />
                    </div>
                </td>
                <td></td>
            </tr>

            <!-- closingComments -->
            <tr>
                <td>{{ 'pages.updates.signal.fieldTitles.closingComments' | translate }}</td>
                <td><span class="preserve-whitespace" [innerHTML]="signal.closingComments | formatHtml"></span></td>
                <td></td>
            </tr>

            <!-- downloadPDF -->
            <tr>
                <td>{{ 'pages.generic.downloadPDF' | translate }}</td>
                <td class="text-center"><img src="../../../assets/images/icons/pdf.png" alt="PDF document icon"
                        class="click" (click)="downloadPDF()" /><br /></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <div class="d-flex">
        <div class="p-1 ps-3">
            <fa-icon [icon]="['fas', 'eye']" class="p-1" (click)="likeSignal()"></fa-icon>
            <span style="font-style: italic;" *ngIf="signal.viewCount">{{signal.viewCount}} {{ 'pages.worldwatch.views'
                | translate }}</span>
            <span style="font-style: italic;" *ngIf="!signal.viewCount">0 {{ 'pages.generic.views' | translate }}</span>
        </div>
        <div class="p-1 ps-3">
            <fa-icon [icon]="['fas', 'thumbs-up']" class="p-1 click" (click)="likeSignal()"></fa-icon>
            <span style="font-style: italic;" *ngIf="signal.likeCount">{{signal.likeCount}} {{
                'pages.updates.signal.fieldTitles.useful' | translate }}</span>
            <span style="font-style: italic;" *ngIf="!signal.likeCount">0 {{ 'pages.updates.signal.fieldTitles.useful' |
                translate }}</span>
        </div>
    </div>

</div>